import { useQuery } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getLeaveReport = async ({
  fromDate,
  toDate,
  companyCode,
  locationCode,
  employeeCode = 0,
}) => {
  const queryString =
    employeeCode !== 0
      ? `FromDate=${fromDate}&ToDate=${toDate}&companyCode=${companyCode}&LocationCode=${locationCode}&Employee=${employeeCode}`
      : `FromDate=${fromDate}&ToDate=${toDate}&companyCode=${companyCode}&LocationCode=${locationCode}`;
  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetLeaveDetails}?${queryString}`,
  );
  return data;
};

export const useLeaveReportQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetLeaveDetails],
    queryFn: () => getLeaveReport(input),
    refetchOnWindowFocus: false,
  });
};

const getEmpLeaveHistoryReport = async ({
  fromDate,
  toDate,
  companyCode,
  locationCode,
  employeeCode = 0,
  isAllCompanies = false,
  selectedCompanyCode = "",
  userId = 0,
}) => {
  const url = isAllCompanies
    ? Api_EndPoints.AllCompanies_GetEmpLeaveHistory
    : Api_EndPoints.GetEmpLeaveHistory;
  let queryString =
    employeeCode !== 0
      ? `LeaveFromDate=${fromDate}&LeaveToDate=${toDate}&companyCode=${isAllCompanies ? selectedCompanyCode : companyCode}&LocationCode=${locationCode}&Employeecode=${employeeCode}`
      : `LeaveFromDate=${fromDate}&LeaveToDate=${toDate}&companyCode=${isAllCompanies ? selectedCompanyCode : companyCode}&LocationCode=${locationCode}`;
  if (isAllCompanies && userId !== 0) {
    queryString += `&UserId=${userId}`;
  }
  const { data } = await http_payroll.get(`${url}?${queryString}`);
  return data;
};

export const useEmpLeaveHistoryReportQuery = (input) => {
  const isAllCompanies = Boolean(input?.isAllCompanies);
  return useQuery({
    queryKey: [
      isAllCompanies
        ? Api_EndPoints.AllCompanies_GetEmpLeaveHistory
        : Api_EndPoints.GetEmpLeaveHistory,
    ],
    queryFn: () => getEmpLeaveHistoryReport(input),
    refetchOnWindowFocus: false,
  });
};
